import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useCountdown } from 'usehooks-ts';
import { differenceInSeconds } from 'date-fns';

import { getEndOfWeekUTC, formatTimeLeft } from '@app/shared/utils/countdownToEndOfWeek';

export function CountdownToEndOfWeek() {
  const countStartS = useMemo(() => differenceInSeconds(getEndOfWeekUTC(), new Date()), []);
  const [timeLeft, { startCountdown }] = useCountdown({
    countStart: countStartS,
    countStop: 0,
    intervalMs: 1000,
  });
  const { t } = useTranslation();

  useEffect(() => {
    startCountdown();
  }, []);

  return (
    <div className="shrink-0 text-[15px] font-medium text-[#0b87f9]">
      ⏰ {formatTimeLeft(timeLeft * 1000, t)}
    </div>
  );
}
